import RolesUtil from 'permissions/utils/roles';
const SideBySideStatementViewPermissions = {
  canSelectElement: (stateData, projectID) =>
    RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData, projectID),
};

export default SideBySideStatementViewPermissions;
